module.exports = __webpack_public_path__ + "static/img/prize_show.9348ee8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/prize_show.png
// module id = 547
// module chunks = 1